import { render, staticRenderFns } from "./ResendToken.vue?vue&type=template&id=6c32c61f&scoped=true&"
import script from "./ResendToken.vue?vue&type=script&lang=js&"
export * from "./ResendToken.vue?vue&type=script&lang=js&"
import style0 from "./ResendToken.vue?vue&type=style&index=0&id=6c32c61f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c32c61f",
  null
  
)

export default component.exports